// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"11e6047f","239":"4454f6bd","455":"1f834e58"}[chunkId] + ".chunk.js";
};